import Text from '../../Atoms/Text';
import Title from '../../Atoms/Title';

interface Props {
  title: string;
  text: string;
}

function CardText({ text, title }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-1 rounded-xl bg-white py-7 px-3 text-center text-sl-blue md:py-16">
      <Title as="h2" weight={500}>
        {title}
      </Title>
      <Text as="span" size="sm">
        {text}
      </Text>
    </div>
  );
}

export default CardText;
